import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import Routes from './routes';
import MesDemarches from './components/mesDemarches/MesDemarches';
import Ceaf from './ceaf';
import RouteSecurisee from '../../../components/RouteSecurisee/RouteSecurisee';
import CreerTitreDetention from './titre-detention/creer/CreerTitreDetention';
import VisualiserTitreDetention from './titre-detention/visualiser/VisualiserTitreDetention';
import { DROITS_AUTORISATION_ACQUISION_DETENTION } from '../../../utils/droitsEtRoles.constant';
import { getPath } from '../../../utils/router';

const MesDemarchesIndex = () => {
    return (
        <>
            <RouteSecurisee
                path={getPath(Routes.subroutes.titreDetetion.subroutes.creer)}
                render={(subProps) => <CreerTitreDetention {...subProps} />}
                exact
                droits={DROITS_AUTORISATION_ACQUISION_DETENTION}
            />

            <RouteSecurisee
                path={getPath(Routes.subroutes.titreDetetion.subroutes.visualiser)}
                render={(subProps) => <VisualiserTitreDetention {...subProps} />}
                exact
                droits={DROITS_AUTORISATION_ACQUISION_DETENTION}
            />

            <Route
                path={getPath(Routes.subroutes.ceaf)}
                render={(subProps) => <Ceaf {...subProps} />}
            />
            <Route
                path={getPath(Routes)}
                render={(subProps) => <MesDemarches {...subProps} />}
                exact
            />
        </>
    );
};

MesDemarchesIndex.propTypes = {};

export default connect()(MesDemarchesIndex);
